module.exports = __webpack_public_path__ + "img/baseCoin.a490c0e2.png";